import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NMessageProvider, NConfigProvider } from 'naive-ui'
import { ContextMenuProvider } from '@/components/contextMenu'
import { DialogProVider } from '@/components/appDialog'
import { DrawerProvider } from '@/components/drawer'
import { watchEffect, watch } from 'vue'
import { useGroupStore } from '@/store/group'
import { loadUIkitComponent } from '@/utils/loadComponent'
import { idle } from '@/utils'
import usePreference from '@teams/common/hooks/usePreference'
import { useActiveElement } from '@vueuse/core'
import AppRouterView from '@/views/appRouterView/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const preference = usePreference({ initBind: true, defaultClient: 'pc' })
const groupStore = useGroupStore()

const activeElement = useActiveElement()
watch(activeElement, el => {
  try {
    // 监听document.activeElement， focus在iframe上时，手动触发鼠标点击事件，触发页面上弹窗/菜单的clickOutsize事件
    if (el && el.nodeName === 'IFRAME') {
      // TODO: 有坑，当内容视图为云管理器时，点击右上角消息按钮，会触发activeElement变化，此时focus的el是云管理器iframe, 此处判断消息弹窗出来时，不模拟点击事件
      const eleMessageBox: HTMLElement | null =
        document.querySelector('#k-message-box')
      if (eleMessageBox && getComputedStyle(eleMessageBox).display !== 'none') {
        // 当消息弹窗打开时，手动将当前的activeElement聚焦到k-message-box中，从而监听keyup事件
        eleMessageBox.focus()
        return
      }
      const mousedownEvent = new MouseEvent('mousedown')
      const mouseupEvent = new MouseEvent('mouseup')
      document.dispatchEvent(mousedownEvent)
      document.dispatchEvent(mouseupEvent)
      document.body.click()
    }
  } catch (e) {}
})
// 监听团队名称变化，修改页面标题
watchEffect(() => {
  const groupName = groupStore.current.name
  if (groupName) {
    document.title = groupName
  }
})

idle(() => {
  // 提前加载uikit组件
  loadUIkitComponent('@uikit/vue-member')
  loadUIkitComponent('@uikit/vue-finder')
  loadUIkitComponent('@uikit/member-card')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    "theme-overrides": _unref(preference).naiveUIOverride,
    class: "team-app-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NMessageProvider), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ContextMenuProvider), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogProVider), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(DrawerProvider), null, {
                    default: _withCtx(() => [
                      _createVNode(AppRouterView)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme-overrides"]))
}
}

})